import * as React from "react";

import { BulkyActionPicker, IActionCommand } from "../../../../common/component/action/action-select/bulky-action-picker";
import { Parcel } from "../../../model/parcel";
import { CanceledParcelActionType } from "../../../constants/constants";
import { observer } from "mobx-react";
import { Permission } from "../../../../context/permission";
import { operationContext } from "../../../../context/operation-context";

interface IParcelCanceledHeaderProps {
    actionsList: Array<IActionCommand<Parcel, CanceledParcelActionType>>;
    reloadParcelsList: () => Promise<void>;
}

@observer
export class ParcelCanceledHeader extends React.Component<IParcelCanceledHeaderProps, {}> {
    public render() {
        return <div className="list-actions-container">
            <div className="list-actions">
                <BulkyActionPicker withScanMode={true}
                                   propertyKey={operationContext.operationCodeOrEmpty}
                                   scanFieldType="text"
                                   inputLabel=""
                                   contentPrefix="parcelCanceled.action"
                                   actions={this.props.actionsList}
                                   permission={Permission.BackOffice}/>
            </div>
        </div>;
    }
}
